import React, { useState, useContext } from 'react';
// import _ from 'lodash';
import moment from 'moment';
import Highlighter from 'react-highlight-words';
import {
  List,
  Button,
  Form,
  Col,
  Row,
  Image,
  Input,
  Tabs,
  Descriptions,
  Divider,
  Tooltip,
  Popconfirm,
  Alert,
  Table,
} from 'antd';
import AppContext from '../../../components/AppContext';
import { CopyOutlined, QuestionCircleOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import gql from 'graphql-tag';
import Collapse from 'react-collapse';
import { useMutation, useQuery } from '@apollo/client';
import { StickyContainer, Sticky } from 'react-sticky';
import CopyToClipboard from 'react-copy-to-clipboard';
import message from '../../../components/message';
import ProgressModal from '../../../components/ProgressModal';
import Pullable from '../../../components/Pullable';

import { ORDER_STATUS, ORDER_PAYMENT_STATUS, ORDER_PAYMENT_METHOD } from '../../../utils/constants';
import {
  OrderStatus,
  OrderWhereInput,
  OrderQueryResult,
  OrderPaymentStatus,
  Package,
} from '../../../utils/types';
import Error from '../../../components/Error';
import { EMAIL_NOTIFICATION_ENABLED, SHOW_CURRENCY_OPTION_IN_ORDER_PAGE, PAYMENT_INFO } from '../../../config';
// import ProgressModal from '../../../components/ProgressModal';

import './index.css';
import CountryIcon from '../../../components/CountryIcon';
import {
  canUpdateOrderAddress,
  canConfirmReceived,
  isGroupMainOrder,
  isGroupSubOrder,
} from '../../../utils/helpers';

const { TextArea } = Input;
const { TabPane } = Tabs;
export const ORDERS_QUERY = gql`
  query OrdersQuery(
    $where: OrderWhereInput!
    $skip: Int
    $count: Int
    $orderBy: OrderOrderByInput
  ) {
    queryUserOrders(where: $where, skip: $skip, count: $count, orderBy: $orderBy) {
      total
      list {
        id
        number
        status
        paymentStatus
        paymentMethod
        notes
        warehouseNotes
        shippingRoute {
          id
          name
          country
          speed
          shippingMethod
          shipmentType
          dimensionalFactor
          isActive
          canGroup
          canDirect
          priceRanges {
              startWeight
              unitPrice
              basePrice
              roundingWeight
          }
          description
        }

        trackingNumber
        shippedAt
        weight
        dimWeight
        chargeWeight
        totalPrice
        serviceName
        serviceProvider

        country
        state
        city
        recipientName
        phone
        address
        zipCode

        images

        packages {
          id
          trackingNumber
          shippingCompany
          weight
          items
          warehouseNotes
          notes
          length
          width
          depth
        }

        parentOrder {
          id
          number
          status
          trackingNumber
          serviceName
          serviceProvider
          shippingRoute {
            id
            name
            country
            speed
            shippingMethod
            shipmentType
            dimensionalFactor
            isActive
            canGroup
            canDirect
            priceRanges {
                startWeight
                unitPrice
                basePrice
                roundingWeight
            }
            description
          }
        }

        shippingGroup {
          id
          name
          type
          hasFixedLeader
          isPrivate
          leader {
            id
            name
            code
          }
        }
      }
    }
  }
`;

const UPDATE_ORDER_MUTATION = gql`
  mutation UpdateOrderMutation($order: OrderInput!, $id: ID!) {
    updateOrder(order: $order, id: $id) {
      id
    }
  }
`;

// const CANCEL_ORDER_MUTATION = gql`
//   mutation DeletePackage($id: ID!) {
//     deletePackage(id: $id) {
//       id
//     }
//   }
// `;

type FormValues = {
  trackingNumbers?: string;
  notes?: string;
  status?: Array<OrderStatus>;
};

function getWhere(formData?: FormValues, additionalQuery?: OrderWhereInput): OrderWhereInput {
  if (!formData) {
    return additionalQuery ? additionalQuery : {};
  }

  const { trackingNumbers, status, notes } = formData;
  const where: OrderWhereInput = {};
  if (trackingNumbers) {
    where.trackingNumber = {
      in: trackingNumbers.split('\n').map(s => s.replace(/[\s,;；，]/g, '')),
    };
  }
  if (status && status.length > 0) {
    where.status = { in: status };
  }

  if (notes) {
    where.notes = { contains: notes };
  }

  if (additionalQuery) {
    return { AND: [additionalQuery, where] };
  } else {
    return where;
  }
}

const renderTabBar = (props, DefaultTabBar) => (
  <Sticky bottomOffset={80}>
    {({ style }) => <DefaultTabBar {...props} style={{ ...style }} />}
  </Sticky>
);

// const call17TrackPopup = (trackingNumber, id) => {
//   console.log('tracking', trackingNumber);
//   // @ts-ignore
//   window?.YQV5?.trackSingleF2({
//     // 必须，指定悬浮位置的元素ID。
//     YQ_ElementId: id,
//     // 可选，指定UI语言，默认根据浏览器自动识别。
//     YQ_Lang: 'zh-CN',
//     // 必须，指定要查询的单号。
//     YQ_Num: trackingNumber,
//   });
// };

function Orders() {
  const [form] = Form.useForm();
  const { user } = useContext(AppContext);

  // const [advancedSearchOpen, setAdvancedSearchVisibility] = useState(false);
  const [where, setWhere] = useState<OrderWhereInput>({});
  const [activeTabKey, setActiveTabKey] = useState('ALL');
  const [orderOpen, setOrderOpen] = useState({});
  const [orderImagesOpen, setOrderImagesOpen] = useState({});

  const { loading, error, data, refetch } = useQuery<{
    queryUserOrders: OrderQueryResult;
  }>(ORDERS_QUERY, {
    variables: { where, orderBy: { createdAt: 'DESC' } },
    fetchPolicy: 'cache-and-network',
  });

  const [updateOrder] = useMutation(UPDATE_ORDER_MUTATION, {
    onError: () => null,
    onCompleted: data => {
      console.log(data);
      ProgressModal.hide();
      message.success('订单状态已更新');
      refetch({
        where,
        orderBy: { createdAt: 'DESC' },
      });
    },
  });

  const changeOrderStatus = (id, status) => {
    ProgressModal.show();

    updateOrder({ variables: { order: { status }, id } });
  };

  const applyFilter = values => {
    console.log(values);
    const where = getWhere(values as FormValues);
    setWhere(where);
    refetch({
      where,
      orderBy: { createdAt: 'DESC' },
    });
  };

  const onTabChange = key => {
    setActiveTabKey(key);
    let status;
    switch (key) {
      case 'CREATED':
      case 'PACKING':
        status = [key];
        break;
      case 'SHIPPED':
        status = ['SHIPPED', 'PICKUP_PENDING'];
        break;
      case 'ALL':
      default:
        status = '';
    }
    const newWhere: OrderWhereInput = { ...where };
    if (status && status.length > 0) {
      newWhere.status = { in: status };
    } else {
      newWhere.status = {};
    }
    if (key === 'PAYMENT_PENDING') {
      newWhere.paymentStatus = {
        in: [OrderPaymentStatus.Unpaid, OrderPaymentStatus.PartiallyPaid],
      };
      newWhere.status = {
        in: [
          OrderStatus.Packed,
          OrderStatus.Shipped,
          OrderStatus.UserReceived,
          OrderStatus.PickupPending,
        ],
      };
    } else {
      newWhere.paymentStatus = {};
    }
    setWhere(newWhere);
    refetch({
      where: newWhere,
      orderBy: { createdAt: 'DESC' },
    });
  };

  const setOrderCollapse = id => {
    const newCollapse = { ...orderOpen };
    newCollapse[id] = !newCollapse[id];
    setOrderOpen(newCollapse);
  };

  const setOrderImagesCollapse = id => {
    const newCollapse = { ...orderImagesOpen };
    newCollapse[id] = !newCollapse[id];
    setOrderImagesOpen(newCollapse);
  };

  if (error) return <Error />;

  const orderList = (
    <>
      <Form form={form} onFinish={applyFilter} style={{ marginBottom: '-10px' }}>
        <Row gutter={3} justify="space-between">
          <Col span={10}>
            <Form.Item name="trackingNumbers">
              <TextArea autoSize rows={1} placeholder="跟踪号(一行一个)" allowClear />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item name="notes">
              <Input placeholder="备注" allowClear />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item>
              <Button size="small" type="primary" htmlType="submit">
                查询
              </Button>
              {/* <Button style={{ marginLeft: '20px' }} onClick={() => setAdvancedSearchVisibility(!advancedSearchOpen)}>
                高级查询
                {advancedSearchOpen ? <UpOutlined /> : <DownOutlined />}
              </Button> */}
            </Form.Item>
          </Col>
        </Row>
        {/* <Collapse isOpened={advancedSearchOpen}>
          <div className="advancedSearchWrapper">
            <Row>
              <Col span={24} style={{ textAlign: 'right' }}>
                <Button type="primary" htmlType="submit">
                  查询
                </Button>
                <Button style={{ marginLeft: 8 }} onClick={handleReset}>
                  重置
                </Button>
              </Col>
            </Row>
          </div>
        </Collapse> */}
      </Form>

      <Pullable onRefresh={refetch}>
        <List
          loading={loading && !data}
          grid={{ gutter: 16, column: 1 }}
          dataSource={data?.queryUserOrders?.list}
          renderItem={order => {
            const tracking = (order.trackingNumber || order.parentOrder?.trackingNumber)
              ?.split(/([^A-Za-z0-9]+)/)
              .map((item, index) => {
                if (!item) return '';
                if (!item.match(/[A-Za-z]/) || !item.match(/[0-9]/)) {
                  if (item.match(/[0-9]/) && item.length === 10 && ((order.serviceName ?? order.parentOrder?.serviceName)?.toUpperCase()?.includes('DHL') || (order.serviceProvider ?? order.parentOrder?.serviceProvider)?.toUpperCase()?.includes('DHL'))) {
                    return (
                      <span key={index}>
                        <a
                          rel="noopener noreferrer"
                          href={`https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=${item}`}
                          target="_blank"
                        >
                          {item}
                        </a>
                        <CopyToClipboard
                          text={item}
                          onCopy={() => {
                            message.success('跟踪号已复制');
                          }}
                        >
                          <span>
                            &nbsp;&nbsp;
                            <CopyOutlined />
                          </span>
                        </CopyToClipboard>
                        &nbsp;&nbsp;&nbsp;
                      </span>
                    );
                  }
                  if (item.match(/[0-9]/) && item.length === 12) {
                    return (
                      <span key={index}>
                        <a
                          rel="noopener noreferrer"
                          href={`https://www.fedex.com/fedextrack/?action=track&tracknumbers=${item}&locale=en_US&cntry_code=us`}
                          target="_blank"
                        >
                          {item}
                        </a>
                        <CopyToClipboard
                          text={item}
                          onCopy={() => {
                            message.success('跟踪号已复制');
                          }}
                        >
                          <span>
                            &nbsp;&nbsp;
                            <CopyOutlined />
                          </span>
                        </CopyToClipboard>
                        &nbsp;&nbsp;&nbsp;
                      </span>
                    );
                  }
                  return (
                    <span style={{ whiteSpace: 'pre' }} key={index}>
                      {item}
                    </span>
                  );
                }
                // return (
                //   <span
                //     key={index}
                //     style={{ cursor: 'pointer', color: '#EB6841' }}
                //     id={order.number + index}
                //     onClick={e => {
                //       e.preventDefault();
                //       call17TrackPopup(item, order.number + index);
                //     }}
                //   >
                //     {item}
                //   </span>
                // );
                return (
                  <span key={index}>
                    <a
                      rel="noopener noreferrer"
                      href={`https://t.17track.net/zh-cn#nums=${item}`}
                      target="_blank"
                    >
                      {item}
                    </a>
                    <CopyToClipboard
                      text={item}
                      onCopy={() => {
                        message.success('跟踪号已复制');
                      }}
                    >
                      <span>
                        &nbsp;&nbsp;
                        <CopyOutlined />
                      </span>
                    </CopyToClipboard>
                    &nbsp;&nbsp;&nbsp;
                  </span>
                );
              });
            return (
              <List.Item>
                <div className="header" onClick={() => setOrderCollapse(order.id)}>
                  <Row gutter={5} justify="space-between">
                    <Col span={16} style={{ color: '#EB6841', fontWeight: 'bold' }}>
                      {order.shippingGroup ? (
                        <span>{order.shippingGroup.name}</span>
                      ) : (
                        <span>#{order.number}</span>
                      )}
                    </Col>
                    <Col span={4}>
                      {order.shippingGroup ? (
                        <span
                          style={{
                            color: order.parentOrder ? '#87d068' : '#fa8c16',
                            fontWeight: 500,
                          }}
                        >
                          {order.parentOrder ? '子' : '主'}订单
                        </span>
                      ) : (
                        order.recipientName
                      )}
                    </Col>

                    <Col
                      span={4}
                      style={{
                        textAlign: 'right',
                        color: ORDER_STATUS[order.status].hexColor,
                      }}
                    >
                      {ORDER_STATUS[order.status].text}
                    </Col>
                  </Row>
                </div>
                <Collapse isOpened={!!orderOpen[order.id]}>
                  <div className="content">
                    <Divider style={{ marginTop: '-5px' }} />
                    {(!order.shippingGroup || order.parentOrder) &&
                      order.status !== 'PICKUP_PENDING' &&
                      order.status !== 'USER_RECEIVED' && (
                        <Alert
                          type="info"
                          message={
                            <div>
                              <Link to="/faq#6">什么时候付款？</Link>
                            </div>
                          }
                          style={{ marginBottom: '0.5rem' }}
                        />
                      )}
                    {order.shippingGroup && !order.parentOrder && (
                      <Alert
                        type="info"
                        message={`请在截团后点下面按钮提交收货地址。到货后点确认收货，${EMAIL_NOTIFICATION_ENABLED ? '系统会发送邮件通知大家取货' : '并在微信群里通知大家取货'}。感谢您作为团长的付出`}
                        style={{ marginBottom: '0.5rem' }}
                      />
                    )}
                    {order.shippingGroup && order.parentOrder && (
                      <Alert
                        type="warning"
                        message="箱号信息和取货地址请点下面拼邮团链接查看"
                        style={{ marginBottom: '0.5rem' }}
                      />
                    )}

                    <Descriptions title="基本信息" size="small" column={2}>
                      {order.shippingGroup && (
                        <>
                          <Descriptions.Item span={2} label="拼邮团">
                            <Link to={`/groups/${order.shippingGroup.id}`}>
                              {order.shippingGroup.isPrivate && '🔒 '}
                              {order.shippingGroup.name}
                            </Link>
                            <CopyToClipboard
                              text={order.shippingGroup.name}
                              onCopy={() => {
                                message.success('团名已复制');
                              }}
                            >
                              <span>
                                &nbsp;&nbsp;
                                <CopyOutlined />
                              </span>
                            </CopyToClipboard>
                          </Descriptions.Item>
                          <Descriptions.Item
                            label={order.shippingGroup.hasFixedLeader ? '固定团长' : '收货团长'}
                            span={2}
                          >
                            {order.shippingGroup?.leader?.name} {order.shippingGroup?.leader?.code}
                          </Descriptions.Item>
                        </>
                      )}

                      <Descriptions.Item label="订单号" span={2}>
                        <CopyToClipboard
                          text={order.number}
                          onCopy={() => {
                            message.success('订单号已复制');
                          }}
                        >
                          <span>
                            {order.number}&nbsp;
                            <CopyOutlined />
                          </span>
                        </CopyToClipboard>
                      </Descriptions.Item>
                      <Descriptions.Item label="状态">
                        {ORDER_STATUS[order.status].text}
                      </Descriptions.Item>

                      <Descriptions.Item label="支付状态">
                        {ORDER_PAYMENT_STATUS[order.paymentStatus].text}
                      </Descriptions.Item>
                      <Descriptions.Item label="支付方式">
                        {order.paymentMethod && ORDER_PAYMENT_METHOD[order.paymentMethod].text}
                      </Descriptions.Item>

                      <Descriptions.Item label="实际重量">
                        {order.weight && `${order.weight.toFixed(2)}kg`}
                      </Descriptions.Item>
                      <Descriptions.Item label="体积重量">
                        {order.dimWeight && `${order.dimWeight.toFixed(2)}kg`}
                      </Descriptions.Item>

                      <Descriptions.Item
                        label={
                          <span>
                            计费重量&nbsp;
                            <Tooltip title="实际重量和体积重量哪个大按哪个计费">
                              <QuestionCircleOutlined />
                            </Tooltip>
                          </span>
                        }
                      >
                        {order.chargeWeight && `${order.chargeWeight.toFixed(2)}kg`}
                      </Descriptions.Item>
                      <Descriptions.Item label="总费用">
                        {order.totalPrice && (
                          <>
                            ￥{order.totalPrice}
                            { SHOW_CURRENCY_OPTION_IN_ORDER_PAGE && `(~USD ${(order.totalPrice / 6.131).toFixed(2)})` }
                          </>
                        )}
                      </Descriptions.Item>

                      <Descriptions.Item label="物流渠道">
                        {(order.shippingRoute || order.parentOrder?.shippingRoute)?.name}
                      </Descriptions.Item>

                      {order.shippedAt && (
                        <Descriptions.Item label="发货时间" span={2}>
                          {moment(order.shippedAt).format('YYYY-MM-DD')}
                        </Descriptions.Item>
                      )}

                      <Descriptions.Item
                        span={2}
                        label={
                          <span>
                            跟踪号&nbsp;
                            <Tooltip title="跟踪号需要在发货几天后才有。对于海运普货，由于跟踪号属于尾程派送的公司(UPS或Fedex)，因此在包裹到达美国且被尾程派送公司提货之前物流也不会更新">
                              <QuestionCircleOutlined />
                            </Tooltip>
                          </span>
                        }
                      >
                        {tracking}
                      </Descriptions.Item>

                      {order.notes && (
                        <Descriptions.Item span={2} label="备注">
                          {order.notes}
                        </Descriptions.Item>
                      )}
                      {order.warehouseNotes && (
                        <Descriptions.Item span={2} label="仓库备注">
                          <Highlighter
                            highlightStyle={{ backgroundColor: '#ffd54f', padding: 0 }}
                            searchWords={[user.code]}
                            autoEscape
                            textToHighlight={order.warehouseNotes || ''}
                            style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}
                          />
                        </Descriptions.Item>
                      )}
                    </Descriptions>
                    {order.paymentStatus !== OrderPaymentStatus.Paid && order.totalPrice && !isGroupMainOrder(order) && PAYMENT_INFO.show && (
                      <>
                        <Divider plain style={{ fontSize: '12px' }}>请选择以下任一方式付款 (已付请忽略)</Divider>

                        <Descriptions size="small" column={2}>
                          <Descriptions.Item span={2} label="转账备注">
                            {order.number}
                            <CopyToClipboard
                              text={order.number}
                              onCopy={() => {
                                message.success('备注已复制');
                              }}
                            >
                              <span>
                                &nbsp;&nbsp;
                                <CopyOutlined />
                              </span>
                            </CopyToClipboard>
                          </Descriptions.Item>
                        </Descriptions>

                        {PAYMENT_INFO.alipay?.enabled && (
                          <Descriptions size="small" column={2}>
                            <Descriptions.Item span={2} label="支付宝账号">
                              {PAYMENT_INFO.alipay.account} ({PAYMENT_INFO.alipay.accountName})
                              <CopyToClipboard
                                text={PAYMENT_INFO.alipay.account}
                                onCopy={() => {
                                  message.success('账号已复制');
                                }}
                              >
                                <span>
                                  &nbsp;&nbsp;
                                  <CopyOutlined />
                                </span>
                              </CopyToClipboard>
                            </Descriptions.Item>
                          </Descriptions>
                        )}

                        {PAYMENT_INFO.taobao?.enabled && (
                          <Descriptions size="small" column={2}>
                            <Descriptions.Item span={2} label="淘宝拍单链接">
                              {PAYMENT_INFO.taobao.link}
                              <CopyToClipboard
                                text={PAYMENT_INFO.taobao.link}
                                onCopy={() => {
                                  message.success('链接已复制，请到浏览器里粘贴打开');
                                }}
                              >
                                <span>
                                  &nbsp;&nbsp;
                                  <CopyOutlined />
                                </span>
                              </CopyToClipboard>
                            </Descriptions.Item>
                          </Descriptions>
                        )}

                        {PAYMENT_INFO.wechatPay?.enabled && (
                          <Descriptions size="small" column={2}>
                            <Descriptions.Item span={2} label="微信 ID">
                              {PAYMENT_INFO.wechatPay.account} ({PAYMENT_INFO.wechatPay.accountName})
                              <CopyToClipboard
                                text={PAYMENT_INFO.wechatPay.account}
                                onCopy={() => {
                                  message.success('账号已复制');
                                }}
                              >
                                <span>
                                  &nbsp;&nbsp;
                                  <CopyOutlined />
                                </span>
                              </CopyToClipboard>
                            </Descriptions.Item>
                          </Descriptions>
                        )}

                        {PAYMENT_INFO.paypal?.enabled && (
                          <Descriptions size="small" column={2}>
                            <Descriptions.Item span={2} label="PayPal 账号">
                              {PAYMENT_INFO.paypal.account} ({PAYMENT_INFO.paypal.accountName})
                              <CopyToClipboard
                                text={PAYMENT_INFO.paypal.account}
                                onCopy={() => {
                                  message.success('账号已复制');
                                }}
                              >
                                <span>
                                  &nbsp;&nbsp;
                                  <CopyOutlined />
                                </span>
                              </CopyToClipboard>
                            </Descriptions.Item>
                          </Descriptions>
                        )}
                      </>
                    )}
                    <Divider />
                    {canConfirmReceived(order) && (
                      <>
                        <Descriptions title="订单操作" size="small" column={2}>
                          <Descriptions.Item label="" span={2}>
                            <Popconfirm
                              title="请确认已经收到了货"
                              onConfirm={() => changeOrderStatus(order.id, 'USER_RECEIVED')}
                              okText="已收货"
                              cancelText="还没有"
                            >
                              <Button type="primary" size="small" style={{ margin: '8px 0' }}>
                                {isGroupMainOrder(order)
                                  ? '已到货，通知团员取货'
                                  : isGroupSubOrder(order)
                                  ? '确认取货'
                                  : '确认收货'}
                              </Button>
                            </Popconfirm>
                          </Descriptions.Item>
                        </Descriptions>
                        <Divider />
                      </>
                    )}
                    {order.shippingGroup && order.parentOrder ? null : (
                      <>
                        <Descriptions title="收货地址" size="small" column={2}>
                          {!order.address && canUpdateOrderAddress(order) && (
                            <Descriptions.Item label="" span={2}>
                              <Link
                                to={{
                                  pathname: `/orders/${order.id}/update-address`,
                                  state: { edit: false, order },
                                }}
                              >
                                <Button type="primary" size="small" style={{ margin: '8px 0' }}>
                                  填写收货地址
                                </Button>
                              </Link>
                            </Descriptions.Item>
                          )}
                          {order.address && canUpdateOrderAddress(order) && (
                            <Descriptions.Item label="" span={2}>
                              <Link
                                to={{
                                  pathname: `/orders/${order.id}/update-address`,
                                  state: { edit: true, order },
                                }}
                              >
                                <Button size="small" style={{ margin: '8px 0' }}>
                                  修改收货地址
                                </Button>
                              </Link>
                            </Descriptions.Item>
                          )}

                          {(order.address || !canUpdateOrderAddress) && (
                            <>
                              <Descriptions.Item label="收件人">
                                <CountryIcon iso={order.country} /> {order.recipientName}
                              </Descriptions.Item>
                              <Descriptions.Item label="电话">{order.phone}</Descriptions.Item>
                              <Descriptions.Item label="地址" span={2}>
                                {order.address}, {order.city}, {order.state}, {order.country}{' '}
                                {order.zipCode}
                              </Descriptions.Item>
                            </>
                          )}
                        </Descriptions>
                        <Divider />
                      </>
                    )}

                    {order.images && (
                      <div>
                        <div className="ant-descriptions-title" onClick={() => setOrderImagesCollapse(order.id)} style={{ cursor: 'pointer' }}>
                          订单图片（{order.images.length}张）点击展开
                        </div>
                        <Collapse isOpened={!!orderImagesOpen[order.id]}>
                          {order.images?.map((image, index) => (
                            <div className="imageWrapper" key={index}>
                              <Image
                                style={{ border: '1px solid #d9d9d9', padding: '8px', borderRadius: '2px'}}
                                src={`/uploads/${image}`}
                              />
                            </div>
                          ))}
                        </Collapse>
                        <Divider />
                      </div>
                    )}

                    <div>
                      <div className="ant-descriptions-title">包裹列表</div>
                      {order.shippingGroup && !order.parentOrder ? (
                        <div style={{ fontSize: '12px' }}>列表过长，请到拼邮团详情页查看</div>
                      ) : (
                        <Table
                          columns={[
                            {
                              title: '快递',
                              dataIndex: 'trackingNumber',
                              render: (text: string, record: Package) => (
                                <div>
                                  {record.shippingCompany}
                                  <br />
                                  {text}
                                </div>
                              ),
                            },
                            {
                              title: '入库实重',
                              dataIndex: 'weight',
                              render: (text: number | null) => {
                                return <div>{text?.toFixed(2)}kg</div>;
                              },
                            },
                            {
                              title: '物品',
                              dataIndex: 'items',
                            },
                          ]}
                          expandable={{
                            defaultExpandAllRows: true,
                            expandIconColumnIndex: -1,
                            expandedRowRender: record => (
                              <div>
                                {record.notes && (
                                  <p style={{ margin: 0 }}>
                                    <ArrowUpOutlined />
                                    备注：{record.notes}
                                  </p>
                                )}

                                {record.depth && (
                                  <p style={{ margin: 0 }}>
                                    <ArrowUpOutlined />
                                    入库尺寸：{record['length']?.toFixed(0)}×
                                    {record['width']?.toFixed(0)}×{record['depth']?.toFixed(0)}cm
                                  </p>
                                )}

                                {record.warehouseNotes && (
                                  <p style={{ margin: 0 }}>
                                    <ArrowUpOutlined />
                                    仓库备注：{record.warehouseNotes}
                                  </p>
                                )}
                              </div>
                            ),
                            rowExpandable: record =>
                              !!record.notes || !!record.warehouseNotes || !!record.depth,
                          }}
                          dataSource={order.packages || []}
                          size="small"
                          rowKey="id"
                          pagination={false}
                        />
                      )}
                    </div>
                  </div>
                </Collapse>
              </List.Item>
            );
          }}
        />
      </Pullable>
    </>
  );

  return (
    <div className="Order">
      <StickyContainer>
        <Tabs
          hideAdd
          centered
          onChange={onTabChange}
          activeKey={activeTabKey}
          renderTabBar={renderTabBar}
        >
          <TabPane tab="全部" key="ALL">
            {orderList}
          </TabPane>
          <TabPane tab="待打包" key="CREATED">
            {orderList}
          </TabPane>
          <TabPane tab="打包中" key="PACKING">
            {orderList}
          </TabPane>
          <TabPane tab="待付款" key="PAYMENT_PENDING">
            {orderList}
          </TabPane>
          <TabPane tab="待收货" key="SHIPPED">
            {orderList}
          </TabPane>
        </Tabs>
      </StickyContainer>
    </div>
  );
}

export default Orders;
